import { ListItemData } from '../../pages/networkDoctors/utils/mapData';

export enum BookmarkActionTypes {
  ADD,
  REMOVE,
  SET,
}

export interface AddBookmark {
  type: BookmarkActionTypes.ADD;
  payload: ListItemData;
}

export interface RemoveBookmark {
  type: BookmarkActionTypes.REMOVE;
  payload: { bookmarkId: number };
}

export interface SetBookmark {
  type: BookmarkActionTypes.SET;
  payload: ListItemData[];
}

export type BookmarkActions = AddBookmark | RemoveBookmark | SetBookmark;
